import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import SidebarCTA from './SidebarCTA';
import SidebarLogo from './SidebarLogo';
import SidebarItem from './SidebarItem';
import SidebarItemGroup from './SidebarItemGroup';
import SidebarItems from './SidebarItems';
import SidebarCollapse from './SidebarCollapse';
import { SidebarContext } from './SidebarContext';
const SidebarComponent = ({ children, className, collapsed = false, ...rest }) => {
    return (_jsx(SidebarContext.Provider, { value: { collapsed }, children: _jsx("aside", { "aria-label": "Sidebar", className: classNames('h-full', collapsed ? 'w-16' : 'w-64'), ...rest, children: _jsx("div", { className: classNames('h-full overflow-y-auto overflow-x-hidden rounded bg-white py-4 px-3 dark:bg-gray-800', className), children: children }) }) }));
};
SidebarComponent.displayName = 'Sidebar';
export const Sidebar = Object.assign(SidebarComponent, {
    Collapse: SidebarCollapse,
    CTA: SidebarCTA,
    Item: SidebarItem,
    Items: SidebarItems,
    ItemGroup: SidebarItemGroup,
    Logo: SidebarLogo,
});
